<script setup lang="ts">
import Button from "@/components/Reusables/Buttons/Button.vue";
import { useModalStore } from "@/stores/modals/modals.store";

const modals = useModalStore();

// Resolves the promise ReportsSelect is awaiting, so generation starts only on Understood. Closing
// by backdrop, the close button or Escape resolves without a result, which reads as declined.
const handleUnderstood = () => modals.closeByName("ReportDisclaimerModal", { action: "confirm" });
</script>

<template>
  <div class="text-type-default t-small flex flex-col gap-4">
    <h2 class="t-sh4 text-type-default">Disclaimer</h2>
    <p>
      To ensure that your LCA results conform to requirements, we currently offer to quality assure your project. We provide this
      service before an internal/external quality assurances or formal use of the LCA documentation.
    </p>
    <p>
      Please write to
      <a
        class="text-app-blue-600 hover:text-app-blue-700"
        href="mailto:support@realtimelca.com"
        >support@realtimelca.com</a
      >, and add this e-mail as a user to this specific project, and we will come back to you within one work day.
    </p>

    <div class="flex">
      <Button
        class="ml-auto"
        label="Understood"
        color="primary"
        data-cy="understood-disclaimer"
        @click="handleUnderstood" />
    </div>
  </div>
</template>
